import { createFileRoute } from '@tanstack/react-router';
import { requireFeature } from '@portal/platform/guards';
import { BuilderPage } from '@/features/template-builder/builder-page';

/** The PDF template builder; see the email builder's route. */
export const Route = createFileRoute('/_app/pdf-templates/builder')({
  staticData: { featureKey: 'template-builder-pdf' },
  beforeLoad: ({ context, location }) =>
    requireFeature(context, location, {
      feature: 'template-builder-pdf',
      permissions: ['template-tyres:read'],
    }),
  component: () => <BuilderPage kind="pdf" />,
});
